module.exports = __webpack_public_path__ + "static/img/play.b9e621e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/play.gif
// module id = Gkvd
// module chunks = 177